import {PostIncomeTaxDetails} from 'domain/usecases';
import {RemotePostIncomeTaxDetails} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {MyPaymentsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostIncomeTaxDetails = (): PostIncomeTaxDetails =>
	new RemotePostIncomeTaxDetails(
		makeBFFApiUrl(MyPaymentsFlowEndPoints.incomeTax),
		makeAuthorizeHttpClientDecorator(),
	);
